import { NavLink } from "react-router-dom";

export const AdminLogo = (): JSX.Element => {
    return (
        <div className="admin-logo-position has-text-centered">
            <NavLink to="/">
                <img src="/i-Function_logo-white3.png" />
            </NavLink>
            <div className="is-size-7 has-text-white">LASSI-D™ ADMIN PORTAL</div>
        </div>
    );
};
